import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/react-hooks';
import { GET_ACCOUNT_VISUALIZER_DATA } from '../../Queries';

import AccountVisualizerCard from './AccountVisualizerCard';
import Loading from '../Loading/Loading';

import { StyledHeaderWrapper, StyledGrid } from './AccountVisualizerStyles';

var _ref2 = React.createElement(
  'div',
  { className: 'loading-wrapper' },
  React.createElement(Loading, null)
);

var _ref3 = React.createElement(
  'h5',
  null,
  'Saved Designs'
);

var _ref4 = React.createElement(
  'h5',
  null,
  'Saved Beds'
);

var _ref5 = React.createElement(
  'h5',
  null,
  'Saved Walls'
);

var AccountVisualizerGrid = function AccountVisualizerGrid(_ref) {
  var addVariantToCart = _ref.addVariantToCart;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      visData = _useState2[0],
      setVisData = _useState2[1];

  var _useQuery = useQuery(GET_ACCOUNT_VISUALIZER_DATA, {
    variables: { userId: window.Dormify.customerId, slug: 'visualizer' },
    onCompleted: function onCompleted(data) {
      return setVisData(data);
    },
    skip: Object.keys(visData).length // only run on load
  }),
      loading = _useQuery.loading,
      error = _useQuery.error;

  var BED_URL = '/pages/visualizer';
  var WALL_URL = '/pages/wall-visualizer';

  if (loading || !Object.keys(visData).length) return _ref2;

  if (error) throw new Error(error);

  if (visData.user.visualizers.length == 0) {
    return React.createElement(
      StyledHeaderWrapper,
      null,
      _ref3,
      React.createElement(
        'a',
        { href: BED_URL },
        'Start New Bed'
      ),
      React.createElement(
        'a',
        { style: { marginLeft: '10px' }, href: WALL_URL },
        'Start New Wall Design'
      )
    );
  }
  var wallVis = visData.user.visualizers.filter(function (vis) {
    return vis.visualizerLink.includes(WALL_URL);
  });
  var bedVis = visData.user.visualizers.filter(function (vis) {
    return vis.visualizerLink.includes(BED_URL);
  });

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      StyledHeaderWrapper,
      null,
      _ref4,
      React.createElement(
        'a',
        { href: BED_URL },
        'Start New Bed'
      )
    ),
    React.createElement(
      StyledGrid,
      { visualizerCount: bedVis.length },
      bedVis.map(function (vis) {
        return React.createElement(AccountVisualizerCard, {
          key: vis.visualizerLink,
          addVariantToCart: addVariantToCart,
          vis: vis,
          setVisData: setVisData,
          visData: visData
        });
      })
    ),
    React.createElement(
      StyledHeaderWrapper,
      null,
      _ref5,
      React.createElement(
        'a',
        { href: WALL_URL },
        'Start New Wall Design'
      )
    ),
    React.createElement(
      StyledGrid,
      { visualizerCount: wallVis.length },
      wallVis.map(function (vis) {
        return React.createElement(AccountVisualizerCard, {
          key: vis.visualizerLink,
          addVariantToCart: addVariantToCart,
          vis: vis,
          setVisData: setVisData,
          visData: visData
        });
      })
    )
  );
};

AccountVisualizerGrid.propTypes = {
  addVariantToCart: PropTypes.func.isRequired
};

export default AccountVisualizerGrid;